import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { TopAgent } from '../../types/dashboard.types';

interface TopAgentsChartProps {
  data: TopAgent[];
}

export const TopAgentsChart: React.FC<TopAgentsChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Top Performing Agents</h3>
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No agent data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Top Performing Agents</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tick={{ fontSize: 12 }} />
          <YAxis dataKey="agentName" type="category" tick={{ fontSize: 12 }} width={120} />
          <Tooltip
            formatter={(value: any, name?: string) => {
              if (name === 'Revenue ($)') {
                return `$${Number(value).toLocaleString()}`;
              }
              return value;
            }}
          />
          <Legend />
          <Bar dataKey="totalSales" fill="#3b82f6" name="Total Sales" />
          <Bar dataKey="totalRevenue" fill="#10b981" name="Revenue ($)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
